const DEFAULT_MAX_AGE_SECONDS = 60 * 60 * 24 * 7;
const PATH = "/";

export function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
  return match ? decodeURIComponent(match[3]) : null;
}

export function setCookie(
  name: string,
  value: string,
  options: { maxAge?: number; path?: string } = {},
): void {
  if (typeof document === "undefined") return;
  const maxAge = options.maxAge ?? DEFAULT_MAX_AGE_SECONDS;
  const path = options.path ?? PATH;
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAge}; path=${path}`;
}

export function removeCookie(name: string): void {
  if (typeof document === "undefined") return;
  document.cookie = `${name}=; max-age=0; path=${PATH}`;
}
